import { render, staticRenderFns } from "./VLV.vue?vue&type=template&id=2d7c1c02&"
import script from "./VLV.vue?vue&type=script&lang=js&"
export * from "./VLV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports